import http from './http';

export async function getServiceFavorites() {
    const { data } = await http.get('/service-favorites');
    return data;
}

export async function setServiceFavorite(id, favorite) {
    return http.put(`/service-favorites/${id}`, { favorite });
}

export function favoritesFirst(services, favoriteIds) {
    const favorites = new Set(favoriteIds);
    const seen = new Set();
    const unique = services.filter((service) => {
        const id = service.serviceId ?? service.id;
        if (seen.has(id)) return false;
        seen.add(id);
        return true;
    });
    return [
        ...unique.filter((service) => favorites.has(service.serviceId ?? service.id)),
        ...unique.filter((service) => !favorites.has(service.serviceId ?? service.id)),
    ];
}
